import clsx from "clsx";
import PropTypes from "prop-types";

import "./Icon.scss";

const Icon = ({name, className, width = 22, height = 22, ...props}) => {
  return (
    <svg draggable="false" className={clsx("base-icon-styles", className)} width={width} height={height} {...props}>
      <use href={`#${name}`} />
    </svg>
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Icon;
